import API from "./api";
import * as routes from './_routes';
import {TokenStorage} from './tokenStorage';
import {GET_USER_EVENTS} from './_routes';

export function fetchUserByToken() {
    return API.get(routes.ME_URL, TokenStorage.getAuthentication())
        .then(response => ({ response }))
        .catch(error => ({ error }))
}

export function fetchUser(id) {
    return API.get(routes.GET_USER + id, TokenStorage.getAuthentication())
        .then(response => ({ response }))
        .catch(error => ({ error }))
}

export function updateUserInformation(bodyFormData) {
    return API({
        method: 'put',
        url: routes.ME_URL,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

export function changePassword(bodyFormData) {
    return API({
        method: 'put',
        url: routes.ME_URL,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

export function updateAccountSettings(bodyFormData) {
    return API({
        method: 'put',
        url: routes.ME_URL,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    });
}

export function fetchEvents(params = {}) {
    return API.get(GET_USER_EVENTS, {params}, TokenStorage.getAuthentication());
}
